import BaseBubbleController from "./BaseBubbleController.js";

function extractActionPayload(dataset = {}, actionKey) {
  const payload = { ...dataset };
  delete payload[actionKey];
  return payload;
}

export default class AssistantToolBubbleController extends BaseBubbleController {
  constructor() {
    super("assistant-tool", "assistant");
  }

  createToolBubble(props = {}) {
    return this.createBubble({
      role: "assistant",
      html:
        typeof props.html === "string"
          ? props.html
          : typeof props.toolUiHtml === "string"
            ? props.toolUiHtml
            : "",
      ...props,
      update: (existingBubble, updates = {}) => {
        const nextBubble = { ...existingBubble, ...updates };
        if (!Object.prototype.hasOwnProperty.call(updates, "html")) {
          nextBubble.html =
            typeof nextBubble.toolUiHtml === "string" ? nextBubble.toolUiHtml : "";
        }
        return nextBubble;
      },
      getContent: (bubble) => bubble?.content || "",
    });
  }

  renderBubbleHtml(bubble) {
    if (typeof bubble?.html === "string") {
      return bubble.html;
    }
    return typeof bubble?.toolUiHtml === "string" ? bubble.toolUiHtml : "";
  }

  buildToolUiApi(toolCallId, uiApi) {
    return {
      updateToolUiHtml: (html) => uiApi?.updateToolUiHtml?.(html),
      clearToolUi: () => uiApi?.clearToolUi?.(),
      updateBubbleHtml: (html, rawContent) =>
        uiApi?.updateBubbleHtml?.(html, rawContent),
      clearBubbleHtml: () => uiApi?.clearBubbleHtml?.(),
      updateBubbleState: (updates) => uiApi?.updateBubbleState?.(updates),
      updateBubble: (bubbleId, updates) => uiApi?.updateBubble?.(bubbleId, updates),
      updateBubbleDurationText: (text) =>
        uiApi?.updateBubbleDurationText?.(text),
      getRootElement: () => uiApi?.getRootElement?.(),
      query: (selector) => uiApi?.query?.(selector) || null,
      queryAll: (selector) => uiApi?.queryAll?.(selector) || [],
      toolCallId,
    };
  }

  async invokeToolHook(toolInstance, hookName, state, toolCallId, uiApi) {
    if (!toolInstance || typeof toolInstance[hookName] !== "function") {
      return;
    }

    try {
      await toolInstance[hookName](
        state,
        this.buildToolUiApi(toolCallId, uiApi)
      );
    } catch {
      // Tool UI hooks should never break the chat runtime.
    }
  }

  onBubbleRendered(bubble, uiApi) {
    const rootElement = uiApi?.getRootElement?.();
    if (!rootElement || typeof bubble?.onToolUiAction !== "function") {
      return;
    }

    rootElement.querySelectorAll("[data-tool-action]").forEach((element) => {
      element.addEventListener("click", (event) => {
        event.stopPropagation();
        const actionResult = bubble.onToolUiAction(
          element.dataset.toolAction,
          extractActionPayload(element.dataset, "toolAction"),
          {
            bubbleId: bubble.bubbleId,
            messageId: bubble.messageId,
            bubble,
            chatAreaMethods: {
              handleOpenFileByPath: (path) => uiApi?.handleOpenFileByPath?.(path),
              handleOpenUrl: (url) => uiApi?.handleOpenUrl?.(url),
            },
          }
        );
        if (actionResult) {
          uiApi?.handleBubbleClickAction?.(actionResult);
        }
      });
    });
  }
}
